import { createFileRoute } from '@tanstack/react-router';
import { SettingsOverview } from '@/components/layout/SettingsWorkspace';

export const Route = createFileRoute('/_dashboard/dashboard/settings/')({
  component: SettingsOverview,
});
